module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section05_03_american-village-0741d98a59e248ab43e38ea466817b97.jpg";